import React from 'react'
import {Container, Row} from 'react-bootstrap'
import CardProduk from 'components/dashboard/dashcomp/card_produk'

export default function rekomendasi() {
    return (
        <Container className="cart-Rekomendasi">
            <h3>Rekomendasi Barang</h3>
            <Row>
                {
                    Produks.map((item, i) => {
                        return (
                            <CardProduk key={i}
                            header={item.header}
                            src={`asset/cart/${item.src}${i + 1}.png`} 
                            alt="produk"
                            text={item.text} potongan={item.potongan}
                            price={item.price} shere="Bagikan Produk"
                            />
                        )
                    })
                }
            </Row>
        </Container>
    )
}


const Produks = [
    {src:"gambar", header:"Komisi 15%", text:"Sensi Duckbill Original / Sensi Mask Duckbill ...", potongan:"Rp. 137.000", price:"Rp. 100.000" },
    {src:"gambar", header:"Komisi 10%", text:"Alquran Hafalan Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000" },
    {src:"gambar", header:"Komisi 15%", text:"Kurma Tunisia Tangkai Timur Tengah ...", potongan:"Rp. 48.500", price:"Rp. 30.000" },
    {src:"gambar", header:"Komisi 15%", text:"Sensi Duckbill Original / Sensi Mask Duckbill ...", potongan:"Rp. 137.000", price:"Rp. 100.000" },
    {src:"gambar", header:"Komisi 10%", text:"Alquran Hafalan Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000" },
    {src:"gambar", header:"Komisi 15%", text:"Kurma Tunisia Tangkai Timur Tengah ...", potongan:"Rp. 48.500", price:"Rp. 30.000" },
    {src:"gambar", header:"Komisi 15%", text:"Sensi Duckbill Original / Sensi Mask Duckbill ...", potongan:"Rp. 137.000", price:"Rp. 100.000" },
    {src:"gambar", header:"Komisi 10%", text:"Alquran Hafalan Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000" },
    {src:"gambar", header:"Komisi 15%", text:"Kurma Tunisia Tangkai Timur Tengah ...", potongan:"Rp. 48.500", price:"Rp. 30.000" },
    {src:"gambar", header:"Komisi 15%", text:"Sensi Duckbill Original / Sensi Mask Duckbill ...", potongan:"Rp. 137.000", price:"Rp. 100.000" },
    {src:"gambar", header:"Komisi 10%", text:"Alquran Hafalan Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000" },
    {src:"gambar", header:"Komisi 15%", text:"Kurma Tunisia Tangkai Timur Tengah ...", potongan:"Rp. 48.500", price:"Rp. 30.000" }
]